module.exports = __webpack_public_path__ + "static/media/400064_01.40c87966.png";